import globals from "imports/globals";
import $ from "cash-dom";
import { gsapTrigger as WyPt } from "Utilities";

const layout = (function () {
    /**
     * Initialize Sticky Image instances
     */
    $(document).ready(function () {
        if (globals.debug) console.log("layout-sticky-image initialized");
        var stickyImages = [];
        if ($(".layout-sticky-image").length) {
            $(".layout-sticky-image")
                .find(".waypoint")
                .each(function () {
                    /*
                    stickyImages.push(
                        new Waypoint({
                            element: $(this)[0],
                            handler: function (dir) {
                                if (dir == "down") {
                                    var hash = "#" + $(this.element).attr("data-describes");
                                    $(hash).addClass("in-view");
                                } else {
                                    var hash = "#" + $(this.element).attr("data-describes");
                                    $(hash).removeClass("in-view");
                                }
                            },
                            // group: "layout-sticky-image",
                            offset: function () {
                             return this.adapter.outerHeight() / 2;
                            },
                        })
                    );
                    */
                    stickyImages.push(
                        new WyPt({
                            element: $(this)[0],
                            offset: {
                                top: "middle-bottom",
                                bottom: "middle-top",
                            },
                            callback: {
                                enter: function (_el, _dir) {
                                    var hash = "#" + $(_el).attr("data-describes");
                                    $(hash).addClass("in-view");
                                },
                                leave: function (_el, _dir) {
                                    var hash = "#" + $(_el).attr("data-describes");
                                    if (_dir == "up") {
                                        $(hash).removeClass("in-view");
                                    }
                                },
                            },
                            // debug: true,
                        })
                    );
                });

            /*
            $(".layout-sticky-image").each(function () {
                new WyPt({
                    element: $(this)[0],
                    offset: {
                        top: "top-bottom",
                        bottom: "bottom-top ",
                    },
                    callback: {
                        enter: function () {
                            if (!globals.isScrolling) $("html").addClass("scroll-snap-y");
                        },
                        leave: function () {
                            console.log("sticky-image leaving");
                            $("html").removeClass("scroll-snap-y");
                        },
                    },
                });
            });
            */
        }
    });
})();

export default layout;
